import { useAtomValue } from 'jotai';
import { ordersAtom } from '../atoms';

export const useOrders = () => {
    const ordersData = useAtomValue(ordersAtom);

    return ordersData;
};
